export const HERSPACE_DAILY_PROMPTS = [
  "What was a moment when someone showed you real respect in a relationship?",
  "What boundary changed your life once you started honoring it?",
  "What does emotional safety look like to you?",
  "What's a green flag you wish more people noticed sooner?",
  "What's something you learned about love the hard way?",
  "What helped you heal after a difficult relationship?",
  "What advice would you give your younger self about relationships?",
  "What makes you feel truly seen in a partnership?",
  "What does healthy communication look like when emotions run high?",
  "What small action from a partner makes a big difference to you?",
];

export function getDailyHerSpacePrompt(date = new Date()) {
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  const index = (year * 1000 + month * 50 + day) % HERSPACE_DAILY_PROMPTS.length;
  return HERSPACE_DAILY_PROMPTS[index];
}

export function getPromptDayKey(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export const HERSPACE_REACTION_TYPES = [
  {
    key: 'support',
    emoji: '\u2764\uFE0F',
    label: 'Support',
  },
  {
    key: 'relate',
    emoji: '\uD83E\uDEF6',
    label: 'Relate',
  },
  {
    key: 'insightful',
    emoji: '\uD83C\uDF31',
    label: 'Insightful',
  },
];
